'use client';

import { useTranslation } from '@whoop/i18n/lang/client';
import { useShallow } from 'zustand/react/shallow';
import { useSiteStore } from '@/store/SiteStoreProvider';

export default function LandingPageHeader({
  skipGiftSelection,
}: {
  skipGiftSelection?: boolean;
}): React.JSX.Element {
  const { asAGift, skipMemSelectFlow } = useSiteStore(
    useShallow((state) => ({
      asAGift: state.asAGift,
      skipMemSelectFlow: state.skipMemSelectFlow,
    })),
  );
  const { t } = useTranslation('joinLandingPage');

  let text = t('joinWhoop');
  if (asAGift || skipGiftSelection) {
    text = t('orderPage:giftWhoop');
  } else if (Boolean(skipMemSelectFlow)) {
    text = t('chooseABand');
  }
  return (
    <h2
      className={
        'mx-0 text-4xl font-semibold tracking-tighter sm:text-5xl md:pb-3 lg:text-6xl'
      }
    >
      {text}
    </h2>
  );
}
